/* eslint-disable no-unused-vars */
import { axiosApiInstance } from '@/api/axios'

const urlBase = '/api/public'

const state = {
  videos: [],
  videosPageLoading: false
}

const getters = {
  videos: (state) => state.videos,
  videosPageLoading: (state) => state.videosPageLoading
}

const mutations = {
  setVideos(state, payload) {
    state.videos = payload
  },
  setVideosPageLoading(state, payload) {
    state.videosPageLoading = payload
  }
}

const actions = {
  fetchVideos({ commit }) {
    commit('setVideosPageLoading', true)
    axiosApiInstance
      .get(`${urlBase}/get_videos`)
      .then((res) => {
        commit('setVideos', res.data.data)
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setTimeout(() => {
          commit('setVideosPageLoading', false)
        }, 500)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
